import { Button, cn } from "@tellescope/design-system";
import { useTranslation } from "react-i18next";

export interface CustomizeHelperTemplateItemProps {
  className?: string;
  title: string;
  description: string;
  disabled?: boolean;
  onUseClick: () => void;
}

export const CustomizeHelperTemplateItem = ({
  className,
  title,
  description,
  disabled,
  onUseClick,
}: CustomizeHelperTemplateItemProps) => {
  const { t } = useTranslation("contacts");

  return (
    <div className={cn("px-4 py-2 rounded-xl flex items-center justify-between bg-white border", className)}>
      <div className="flex flex-col gap-0.5 text-sm">
        <span className="font-semibold">{title}</span>
        <span className="text-muted-foreground font-light">{description}</span>
      </div>
      <Button variant="outline" size="sm" disabled={disabled} onClick={onUseClick}>
        {t("Use")}
      </Button>
    </div>
  );
};
